// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoBox_container__IKTLe","content":"InfoBox_content__HnM0Y","text":"InfoBox_text__4U3Zk"};